import { Button, styled } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { theme } from '@unicorn/bms-theme';

export const MenuHeader = styled('div')`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const MainButton = styled(Button)`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const CheckedMark = styled('div')`
  width: 36px;
`;

export const CheckIconCustom = styled(CheckIcon)`
  font-size: 20px;
  color: ${theme.palette.action.active};
`;
